export interface Rider {
  id: string;
  name: string;
  phone: string;
  active: boolean;
}

const KEY = 'sipdash_riders';

const DEFAULT_RIDERS: Rider[] = [
  { id: 'r1', name: 'Marcus Johnson', phone: '+592-611-0001', active: true },
  { id: 'r2', name: 'Troy Williams', phone: '+592-611-0002', active: true },
  { id: 'r3', name: 'Keisha Brown', phone: '+592-611-0003', active: true },
  { id: 'r4', name: 'Devon Clarke', phone: '+592-611-0004', active: false },
  { id: 'r5', name: 'Simone Peters', phone: '+592-611-0005', active: true },
];

export function getRiders(): Rider[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) {
      localStorage.setItem(KEY, JSON.stringify(DEFAULT_RIDERS));
      return DEFAULT_RIDERS;
    }
    return JSON.parse(raw) as Rider[];
  } catch {
    return DEFAULT_RIDERS;
  }
}

export function saveRiders(riders: Rider[]): void {
  localStorage.setItem(KEY, JSON.stringify(riders));
}

export function addRider(name: string, phone: string): Rider {
  const newRider: Rider = {
    id: `rider_${Date.now()}`,
    name: name.trim(),
    phone: phone.trim(),
    active: true,
  };
  saveRiders([...getRiders(), newRider]);
  return newRider;
}

export function removeRider(id: string): void {
  saveRiders(getRiders().filter((r) => r.id !== id));
}

export function toggleRiderActive(id: string): void {
  saveRiders(getRiders().map((r) => (r.id === id ? { ...r, active: !r.active } : r)));
}

export function getActiveRiders(): Rider[] {
  return getRiders().filter((r) => r.active);
}
